import React, { useRef } from "react";
import logo from "./images/home_background.png";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import ResponsiveAppBar from "./components/navBar";
import { Box, Button, Typography } from "@mui/material";

import ViviaProjects from "./components/viviaProjects";
import ViviaPatners from "./components/partners";
import ViviaDefiniation from "./components/viviaDefinition";
import Mobility from "./components/mobility";
import ViviaContact from "./components/viviaContact";
import BlogsVivia from "./components/blogs";
import Footer from "./components/footer";
import { useTranslation } from "react-i18next";
import ViviaKeys from "./components/viviaKeys";

function App() {
  const { t } = useTranslation();
  const homePage = useRef<any>(null);
  const aboutUs = useRef<any>(null);
  const features = useRef<any>(null);
  const projects = useRef<any>(null);
  const blog = useRef<any>(null);
  const contactRef = useRef<any>(null);
  const scrollToHomePage = () => {
    homePage.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToAboutUs = () => {
    aboutUs.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToFeatures = () => {
    features.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToProjects = () => {
    projects.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToBlog = () => {
    blog.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <Box>
      {/* first part: nav bar and global text */}
      <Box
        sx={{
          width: "100%",
          height: { sx: 500, lg: 460 },
          pt: 15,
          pb: 2,
          background: ` url(${logo}),
          radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)
         
        `,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <ResponsiveAppBar
          scrollToHomePage={scrollToHomePage}
          scrollToAboutUs={scrollToAboutUs}
          scrollToFeatures={scrollToFeatures}
          scrollToProjects={scrollToProjects}
          scrollToBlog={scrollToBlog}
          scrollToContact={scrollToContact}
        />
        <Box
          ref={homePage}
          style={{ scrollMarginTop: "90px" }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          pb={3}
        >
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "IBM Plex Sans",
              fontWeight: 400,
              fontSize: { xs: "50px", md: "59px", lg: "79px" },

              letterSpacing: "7%",
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            {t("With Artificial Intelligence")}{" "}
          </Typography>
          <Typography
            sx={{
              background:
                "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",

              fontFamily: "Orbitron",
              fontWeight: 900,

              fontSize: { xs: "35px", md: "47px", lg: "67px" },
              letterSpacing: "6%",
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            {t("We bring software to life")}{" "}
          </Typography>
          <Typography
            sx={{
              mt: 3,
              fontFamily: "Roboto",
              fontWeight: 400,
              fontSize: { sm: "24px", md: "26px" },
              lineHeight: "35px",
              letterSpacing: "6%",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#FFF",
              width: "65%",
            }}
          >
            {t(
              "We turn complexity into clarity — crafting intelligent mobility journeys driven by real user needs"
            )}
          </Typography>
          <Button
            sx={{
              color: "#FFF",
              border: "1px solid #28D1B4",
              bgcolor: " #33BBA4",
              mt: 5,
            }}
            onClick={() => scrollToContact()}
          >
            {t("Contact Us")}
          </Button>
        </Box>
      </Box>
      {/* Partner */}
      <ViviaPatners />

      {/* Vivia description */}
      <ViviaDefiniation ref={aboutUs} />
      <section ref={features} style={{ scrollMarginTop: "80px" }}>
        {/* information from keys  */}
        <ViviaKeys />
        {/* Mobility */}
        <Mobility />
      </section>
      {/* </Contact> */}
      <ViviaContact ref={contactRef} />
      {/* connect system  */}
      <ViviaProjects ref={projects} />
      {/* Blogs */}
      <BlogsVivia ref={blog} />
      <Footer
        scrollToHomePage={scrollToHomePage}
        scrollToAboutUs={scrollToAboutUs}
        scrollToFeatures={scrollToFeatures}
        scrollToProjects={scrollToProjects}
        scrollToBlog={scrollToBlog}
        scrollToContact={scrollToContact}
      />
    </Box>
    //{" "}
  );
}

export default App;
